import { IToggleFornecedorDesqualificadoUseCase } from "../../../presentation/useCases/update/toggle_fornecedor_desqualificado_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * ToggleFornecedorDesqualificadoUseCase
 */

export class ToggleFornecedorDesqualificadoUseCase implements IToggleFornecedorDesqualificadoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async toggleFornecedorDesqualificado(
    idFornecedor: number,
  ): Promise<void> {
    await this.repository.toggleFornecedorDesqualificado(
      idFornecedor,
    );
  }
}
